import React from 'react';
import { Modal } from 'react-bootstrap';
import { useModalHandler } from '../../../helper/custom_hook';

export function FeedbackModal({ feedback, schoolName, children }) {
    const { toggleModal, status } = useModalHandler();
    return (
        <>
            {children ? (
                <div onClick={toggleModal} style={{ cursor: 'pointer' }}>{children}</div>
            ) : (
                <button onClick={toggleModal} className='btn btn-sm btn-soft-info me-1'>
                    <i className="ri-chat-3-line" />
                </button>
            )}
            <Modal className="fade" centered={true} show={status} onHide={toggleModal}>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fs-15">Feedback Remarks</Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4">
                    <div className="d-flex align-items-start mb-3">
                        <div className="avatar-xs flex-shrink-0 me-3">
                            <span className="avatar-title rounded-circle bg-soft-primary text-primary fs-18 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                <i className="ri-message-2-line"></i>
                            </span>
                        </div>
                        <div className="flex-grow-1 ms-2">
                            <h5 className="fs-14 mb-1">{schoolName || "Enquiry Feedback"}</h5>
                            <p className="text-muted fs-13 mb-0">Recorded feedback for this enquiry:</p>
                        </div>
                    </div>
                    <div className="p-3 bg-light rounded text-muted fs-13 border border-dashed" style={{ whiteSpace: 'pre-wrap' }}>
                        {feedback ? feedback : <em className="text-muted">No feedback or remarks available for this enquiry.</em>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={toggleModal}>Close</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
